export enum BookingTypeValues {
  OnlySpaces = 'Only Spaces',
  OnlyAccommodations = 'Only Accommodations',
  AccommodationAndSpaces = 'Accommodations + Spaces',
}
